import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SignUpForm from './SignUpForm';
import SignUpSent from './SignUpSent';
import useClose from '../AuthContainer/useClose';

function SignUp ({ onLogin, ...rest }) {
  const [sent, setSent] = useState('');
  useClose(onLogin);
  if (!sent)
    return <SignUpForm onSent={setSent} onLogin={onLogin} {...rest}/>;

  return <SignUpSent email={sent} onLogin={onLogin}/>;
}

export default SignUp;

SignUp.propTypes = {
  onLogin: PropTypes.func
};
